import React from 'react';
import { ButtonProps } from './Button.types';
import { LoadingSpinner } from '../LoadingSpinner';

const variantClasses: Record<ButtonProps['variant'], string> = {
  primary: 'bg-blue-600 hover:bg-blue-700 text-white',
  secondary: 'bg-navy-700 hover:bg-navy-600 text-white',
  danger: 'bg-red-600 hover:bg-red-700 text-white',
  success: 'bg-green-600 hover:bg-green-700 text-white',
  warning: 'bg-yellow-400 hover:bg-yellow-500 text-navy-900',
  production: 'bg-yellow-400 hover:bg-yellow-500 text-navy-900',
  ghost: 'bg-transparent hover:bg-navy-700 text-gray-300',
};

const sizeClasses: Record<ButtonProps['size'], string> = {
  xs: 'px-2 py-1 text-xs',
  sm: 'px-2.5 py-1.5 text-xs',
  md: 'px-3 py-2 text-sm',
  lg: 'px-4 py-2.5 text-base',
};

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  icon: Icon,
  iconPosition = 'left',
  disabled,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const isDisabled = disabled || loading;

  const baseClasses = 'inline-flex items-center justify-center gap-1.5 rounded transition-all duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed';
  const variantClass = variantClasses[variant];
  const sizeClass = sizeClasses[size];
  const disabledClass = isDisabled && variant !== 'ghost' ? 'disabled:bg-gray-600' : '';

  const iconSizeClass = size === 'xs' ? 'w-3 h-3' : size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  
  // Determinar cor do spinner baseado na variante
  const spinnerColor = variant === 'warning' || variant === 'production' ? 'white' : 'white';

  const combinedClasses = `${baseClasses} ${variantClass} ${sizeClass} ${disabledClass} ${className}`.trim();

  return (
    <button
      {...props}
      disabled={isDisabled}
      className={combinedClasses}
    >
      {loading && (
        <LoadingSpinner size="sm" color={spinnerColor} className="flex-shrink-0" />
      )}
      {!loading && Icon && iconPosition === 'left' && (
        <Icon className={`flex-shrink-0 ${iconSizeClass}`} />
      )}
      {children}
      {!loading && Icon && iconPosition === 'right' && (
        <Icon className={`flex-shrink-0 ${iconSizeClass}`} />
      )}
    </button>
  );
}

